/**
 * Statut du rappel de rendez-vous exposé par le back sur les routes de lecture d'action.
 * Miroir de `EnumAppointmentReminderStatus` (bbj-package/src/enums/appointmentReminder.ts).
 */
export enum EnumAppointmentReminderStatus {
  NOT_SCHEDULED = "not_scheduled",
  SCHEDULED = "scheduled",
  SENT = "sent",
  FAILED = "failed",
}
